// @mui
import { enUS } from '@mui/material/locale';
// components
import { SettingsValueProps } from './components/settings/type';
// routes
import { PATH_DASHBOARD } from './routes/paths';

// API
// ----------------------------------------------------------------------

export const HOST_API = window.config.REACT_APP_HOST_API_KEY || '';
export const MAX_PAYLOAD = Number(window.config.MAX_PAYLOAD) * 1024 * 1024 || 50 * 1024 * 1024;

export const FIREBASE_API = {
  apiKey: window.config.REACT_APP_FIREBASE_API_KEY,
  authDomain: window.config.REACT_APP_FIREBASE_AUTH_DOMAIN,
  databaseURL: window.config.REACT_APP_FIREBASE_DATABASE_URL,
  projectId: window.config.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: window.config.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: window.config.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: window.config.REACT_APP_FIREBASE_APPID,
  measurementId: window.config.REACT_APP_FIREBASE_MEASUREMENT_ID,
};

export const COGNITO_API = {
  userPoolId: window.config.REACT_APP_AWS_COGNITO_USER_POOL_ID,
  clientId: window.config.REACT_APP_AWS_COGNITO_CLIENT_ID,
};

export const AUTH0_API = {
  clientId: window.config.REACT_APP_AUTH0_CLIENT_ID,
  domain: window.config.REACT_APP_AUTH0_DOMAIN,
};

export const MAPBOX_API = window.config.REACT_APP_MAPBOX_API;

// ROOT PATH AFTER LOGIN SUCCESSFUL
export const PATH_AFTER_LOGIN = PATH_DASHBOARD.cases.list; // as '/dashboard/app'

// LAYOUT
// ----------------------------------------------------------------------

export const HEADER = {
  MOBILE_HEIGHT: 64,
  MAIN_DESKTOP_HEIGHT: 88,
  DASHBOARD_DESKTOP_HEIGHT: 92,
  DASHBOARD_DESKTOP_OFFSET_HEIGHT: 92 - 32,
};

export const NAVBAR = {
  BASE_WIDTH: 200,
  DASHBOARD_WIDTH: 200,
  DASHBOARD_COLLAPSE_WIDTH: 88,
  //
  DASHBOARD_ITEM_ROOT_HEIGHT: 48,
  DASHBOARD_ITEM_SUB_HEIGHT: 40,
  DASHBOARD_ITEM_HORIZONTAL_HEIGHT: 32,
};

export const ICON = {
  NAVBAR_ITEM: 22,
  NAVBAR_ITEM_HORIZONTAL: 20,
};

// SETTINGS
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const defaultSettings: SettingsValueProps = {
  themeMode: 'dark',
  themeDirection: 'ltr',
  themeContrast: 'default',
  themeLayout: 'horizontal',
  themeColorPresets: 'default',
  themeStretch: true,
};

// MULTI LANGUAGES
// Please remove `localStorage` when you change settings.
// ----------------------------------------------------------------------

export const allLangs = [
  {
    label: 'English',
    value: 'en',
    systemValue: enUS,
    icon: '/assets/icons/flags/ic_flag_en.svg',
  },
  // {
  //   label: 'French',
  //   value: 'fr',
  //   systemValue: frFR,
  //   icon: '/assets/icons/flags/ic_flag_fr.svg',
  // },
  // {
  //   label: 'Vietnamese',
  //   value: 'vn',
  //   systemValue: viVN,
  //   icon: '/assets/icons/flags/ic_flag_vn.svg',
  // },
  // {
  //   label: 'Chinese',
  //   value: 'cn',
  //   systemValue: zhCN,
  //   icon: '/assets/icons/flags/ic_flag_cn.svg',
  // },
  // {
  //   label: 'Arabic (Sudan)',
  //   value: 'ar',
  //   systemValue: arSD,
  //   icon: '/assets/icons/flags/ic_flag_sa.svg',
  // },
];

export const modalities = ['all', 'CT', 'MR', 'DX', 'CR', 'NM', 'PT', 'US', 'XA', 'DR', 'MG'];

export const UIPreferences = {
  showPasswordInInput: window.config.SHOW_PASSWORD_IN_INPUT
};

export const defaultLang = allLangs[0]; // English
